module.exports = __webpack_public_path__ + "static/media/visa.ff369998.svg";